import { ReactNode } from 'react';
import classes from 'classnames';
import Chevron from 'assets/icons/chevron.svg?react';
import { IconElement } from 'types/IconElement';
import styles from 'components/Accordion/AccordionItem.module.scss';

export type AccordionItemProps = {
  title: string;
  Icon?: IconElement;
  children: ReactNode;
  onClick: () => void;
  active: boolean;
  titleClassName?: string;
  dataTest?: string;
};

export default function AccordionItem({
  active,
  children,
  title,
  onClick,
  Icon,
  titleClassName,
  dataTest = 'accordionItem',
}: AccordionItemProps) {
  return (
    <div className={styles.container} data-test={dataTest}>
      <button
        className={styles.head}
        onClick={onClick}
        data-test="accordion-item-head"
        role="menuitem"
        type="button"
      >
        <div
          className={classes(styles.title, titleClassName)}
          data-test="accordion-item-title"
        >
          {Icon && (
            <div className={styles.icon}>
              <Icon data-test="accordion-item-icon" />
            </div>
          )}
          {title}
        </div>
        <Chevron
          className={classes(styles.chevron, active && styles.open)}
          data-test="accordion-item-chevron"
        />
      </button>
      <div
        className={classes(
          styles.accordion,
          active ? styles.open : styles.close,
        )}
      >
        <div className={styles.content} data-test="accordion-item-content">
          {children}
        </div>
      </div>
    </div>
  );
}
